export const themeData = {
  "editLinks": false,
  "docsDir": "",
  "editLinkText": "",
  "lastUpdated": false,
  "navbar": [
    {
      "text": "Packages",
      "children": [
        {
          "text": "Console",
          "link": "/packages/console/"
        },
        {
          "text": "Console Colors",
          "link": "/packages/console-colors/"
        },
        {
          "text": "Console Input",
          "link": "/packages/console-input/"
        },
        {
          "text": "Console Output",
          "link": "/packages/console-output/"
        },
        {
          "text": "Core",
          "link": "/packages/core/"
        },
        {
          "text": "Shared",
          "link": "/packages/shared/"
        },
        {
          "text": "Multi Package Json Manager",
          "link": "/packages/multi-package-json-manager/"
        }
      ]
    },
    {
      "text": "Guide",
      "link": "/guide/"
    },
    {
      "text": "Config",
      "link": "/config/"
    }
  ],
  "sidebarDepth": 5,
  "sidebar": {
    "/guide/": [
      {
        "text": "Guide",
        "children": [
          "",
          "using-vue"
        ]
      }
    ],
    "/packages/console/": [
      {
        "text": "Console",
        "link": "/packages/console/",
        "children": []
      }
    ],
    "/packages/console-colors/": [
      {
        "text": "Console Colors",
        "link": "/packages/console-colors/",
        "children": [
          {
            "text": "api",
            "link": "/packages/console-colors/api/",
            "children": [
              {
                "text": "classes",
                "link": "/packages/console-colors/api/classes/",
                "children": [
                  {
                    "text": "Colors",
                    "link": "/packages/console-colors/api/classes/Colors/",
                    "children": []
                  },
                  {
                    "text": "Parser",
                    "link": "/packages/console-colors/api/classes/Parser/",
                    "children": []
                  }
                ]
              },
              {
                "text": "interfaces",
                "link": "/packages/console-colors/api/interfaces/",
                "children": [
                  {
                    "text": "AnsiRgbColors",
                    "link": "/packages/console-colors/api/interfaces/AnsiRgbColors/",
                    "children": []
                  },
                  {
                    "text": "ParserParsedTag",
                    "link": "/packages/console-colors/api/interfaces/ParserParsedTag/",
                    "children": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "/packages/console-input/": [
      {
        "text": "Console Input",
        "link": "/packages/console-input/",
        "children": [
          {
            "text": "getting-started",
            "link": "/packages/console-input/getting-started/",
            "children": []
          },
          {
            "text": "api",
            "link": "/packages/console-input/api/",
            "children": [
              {
                "text": "classes",
                "link": "/packages/console-input/api/classes/",
                "children": [
                  {
                    "text": "Input",
                    "link": "/packages/console-input/api/classes/Input/",
                    "children": []
                  }
                ]
              },
              {
                "text": "interfaces",
                "link": "/packages/console-input/api/interfaces/",
                "children": [
                  {
                    "text": "AutocompleteQuestion",
                    "link": "/packages/console-input/api/interfaces/AutocompleteQuestion/",
                    "children": []
                  },
                  {
                    "text": "AutocompleteQuestionOptions",
                    "link": "/packages/console-input/api/interfaces/AutocompleteQuestionOptions/",
                    "children": []
                  },
                  {
                    "text": "ColorQuestion",
                    "link": "/packages/console-input/api/interfaces/ColorQuestion/",
                    "children": []
                  },
                  {
                    "text": "ColorQuestionOptions",
                    "link": "/packages/console-input/api/interfaces/ColorQuestionOptions/",
                    "children": []
                  },
                  {
                    "text": "DatepickerQuestion",
                    "link": "/packages/console-input/api/interfaces/DatepickerQuestion/",
                    "children": []
                  },
                  {
                    "text": "DatepickerQuestionOptions",
                    "link": "/packages/console-input/api/interfaces/DatepickerQuestionOptions/",
                    "children": []
                  },
                  {
                    "text": "DirectoryQuestion",
                    "link": "/packages/console-input/api/interfaces/DirectoryQuestion/",
                    "children": []
                  },
                  {
                    "text": "DirectoryQuestionOptions",
                    "link": "/packages/console-input/api/interfaces/DirectoryQuestionOptions/",
                    "children": []
                  },
                  {
                    "text": "FileFolderQuestion",
                    "link": "/packages/console-input/api/interfaces/FileFolderQuestion/",
                    "children": []
                  },
                  {
                    "text": "FilePathQuestion",
                    "link": "/packages/console-input/api/interfaces/FilePathQuestion/",
                    "children": []
                  },
                  {
                    "text": "FileSelectorQuestion",
                    "link": "/packages/console-input/api/interfaces/FileSelectorQuestion/",
                    "children": []
                  },
                  {
                    "text": "FileSelectorQuestionOptions",
                    "link": "/packages/console-input/api/interfaces/FileSelectorQuestionOptions/",
                    "children": []
                  },
                  {
                    "text": "FileTreeSelectionQuestion",
                    "link": "/packages/console-input/api/interfaces/FileTreeSelectionQuestion/",
                    "children": []
                  },
                  {
                    "text": "FileTreeSelectionQuestionOptions",
                    "link": "/packages/console-input/api/interfaces/FileTreeSelectionQuestionOptions/",
                    "children": []
                  },
                  {
                    "text": "FuzzypathQuestion",
                    "link": "/packages/console-input/api/interfaces/FuzzypathQuestion/",
                    "children": []
                  },
                  {
                    "text": "MaxinputQuestion",
                    "link": "/packages/console-input/api/interfaces/MaxinputQuestion/",
                    "children": []
                  },
                  {
                    "text": "MaxinputQuestionOptions",
                    "link": "/packages/console-input/api/interfaces/MaxinputQuestionOptions/",
                    "children": []
                  },
                  {
                    "text": "MyQuestionMap",
                    "link": "/packages/console-input/api/interfaces/MyQuestionMap/",
                    "children": []
                  },
                  {
                    "text": "PathQuestion",
                    "link": "/packages/console-input/api/interfaces/PathQuestion/",
                    "children": []
                  },
                  {
                    "text": "PathQuestionOptions",
                    "link": "/packages/console-input/api/interfaces/PathQuestionOptions/",
                    "children": []
                  },
                  {
                    "text": "SuggestQuestion",
                    "link": "/packages/console-input/api/interfaces/SuggestQuestion/",
                    "children": []
                  },
                  {
                    "text": "SuggestQuestionOptions",
                    "link": "/packages/console-input/api/interfaces/SuggestQuestionOptions/",
                    "children": []
                  },
                  {
                    "text": "TableQuestion",
                    "link": "/packages/console-input/api/interfaces/TableQuestion/",
                    "children": []
                  },
                  {
                    "text": "TableQuestionOptions",
                    "link": "/packages/console-input/api/interfaces/TableQuestionOptions/",
                    "children": []
                  },
                  {
                    "text": "TreeItem",
                    "link": "/packages/console-input/api/interfaces/TreeItem/",
                    "children": []
                  },
                  {
                    "text": "TreeQuestion",
                    "link": "/packages/console-input/api/interfaces/TreeQuestion/",
                    "children": []
                  },
                  {
                    "text": "TreeQuestionOptions",
                    "link": "/packages/console-input/api/interfaces/TreeQuestionOptions/",
                    "children": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "/packages/console-output/": [
      {
        "text": "Console Output",
        "link": "/packages/console-output/",
        "children": [
          {
            "text": "api",
            "link": "/packages/console-output/api/",
            "children": [
              {
                "text": "classes",
                "link": "/packages/console-output/api/classes/",
                "children": [
                  {
                    "text": "Colors",
                    "link": "/packages/console-output/api/classes/Colors/",
                    "children": []
                  },
                  {
                    "text": "Erase",
                    "link": "/packages/console-output/api/classes/Erase/",
                    "children": []
                  },
                  {
                    "text": "FiguresParser",
                    "link": "/packages/console-output/api/classes/FiguresParser/",
                    "children": []
                  },
                  {
                    "text": "GeneratedIcon",
                    "link": "/packages/console-output/api/classes/GeneratedIcon/",
                    "children": []
                  },
                  {
                    "text": "IconGenerator",
                    "link": "/packages/console-output/api/classes/IconGenerator/",
                    "children": []
                  },
                  {
                    "text": "IterableManager",
                    "link": "/packages/console-output/api/classes/IterableManager/",
                    "children": []
                  },
                  {
                    "text": "Move",
                    "link": "/packages/console-output/api/classes/Move/",
                    "children": []
                  },
                  {
                    "text": "Output",
                    "link": "/packages/console-output/api/classes/Output/",
                    "children": []
                  },
                  {
                    "text": "OutputUtil",
                    "link": "/packages/console-output/api/classes/OutputUtil/",
                    "children": []
                  },
                  {
                    "text": "ProgressBar",
                    "link": "/packages/console-output/api/classes/ProgressBar/",
                    "children": []
                  },
                  {
                    "text": "StyleManager",
                    "link": "/packages/console-output/api/classes/StyleManager/",
                    "children": []
                  },
                  {
                    "text": "StyleParser",
                    "link": "/packages/console-output/api/classes/StyleParser/",
                    "children": []
                  },
                  {
                    "text": "Text",
                    "link": "/packages/console-output/api/classes/Text/",
                    "children": []
                  },
                  {
                    "text": "Ui",
                    "link": "/packages/console-output/api/classes/Ui/",
                    "children": []
                  },
                  {
                    "text": "UiBase",
                    "link": "/packages/console-output/api/classes/UiBase/",
                    "children": []
                  }
                ]
              },
              {
                "text": "interfaces",
                "link": "/packages/console-output/api/interfaces/",
                "children": [
                  {
                    "text": "AnsiRgbColors",
                    "link": "/packages/console-output/api/interfaces/AnsiRgbColors/",
                    "children": []
                  },
                  {
                    "text": "ChalkFunction",
                    "link": "/packages/console-output/api/interfaces/ChalkFunction/",
                    "children": []
                  },
                  {
                    "text": "ColorsParserParsedTag",
                    "link": "/packages/console-output/api/interfaces/ColorsParserParsedTag/",
                    "children": []
                  },
                  {
                    "text": "ColumnsOptions",
                    "link": "/packages/console-output/api/interfaces/ColumnsOptions/",
                    "children": []
                  },
                  {
                    "text": "Erasers",
                    "link": "/packages/console-output/api/interfaces/Erasers/",
                    "children": []
                  },
                  {
                    "text": "Figures",
                    "link": "/packages/console-output/api/interfaces/Figures/",
                    "children": []
                  },
                  {
                    "text": "GenerateOptions",
                    "link": "/packages/console-output/api/interfaces/GenerateOptions/",
                    "children": []
                  },
                  {
                    "text": "IconData",
                    "link": "/packages/console-output/api/interfaces/IconData/",
                    "children": []
                  },
                  {
                    "text": "IconsOptions",
                    "link": "/packages/console-output/api/interfaces/IconsOptions/",
                    "children": []
                  },
                  {
                    "text": "IParser",
                    "link": "/packages/console-output/api/interfaces/IParser/",
                    "children": []
                  },
                  {
                    "text": "IParserConstructor",
                    "link": "/packages/console-output/api/interfaces/IParserConstructor/",
                    "children": []
                  },
                  {
                    "text": "MacroProxy",
                    "link": "/packages/console-output/api/interfaces/MacroProxy/",
                    "children": []
                  },
                  {
                    "text": "macros.MacroDefinition",
                    "link": "/packages/console-output/api/interfaces/macros.MacroDefinition/",
                    "children": []
                  },
                  {
                    "text": "ManagerMacroProxy",
                    "link": "/packages/console-output/api/interfaces/ManagerMacroProxy/",
                    "children": []
                  },
                  {
                    "text": "Movers",
                    "link": "/packages/console-output/api/interfaces/Movers/",
                    "children": []
                  },
                  {
                    "text": "Options",
                    "link": "/packages/console-output/api/interfaces/Options/",
                    "children": []
                  },
                  {
                    "text": "OutputConfig",
                    "link": "/packages/console-output/api/interfaces/OutputConfig/",
                    "children": []
                  },
                  {
                    "text": "OutputOptions",
                    "link": "/packages/console-output/api/interfaces/OutputOptions/",
                    "children": []
                  },
                  {
                    "text": "OutputOptionsTableStyle",
                    "link": "/packages/console-output/api/interfaces/OutputOptionsTableStyle/",
                    "children": []
                  },
                  {
                    "text": "OutputOptionsTableStyles",
                    "link": "/packages/console-output/api/interfaces/OutputOptionsTableStyles/",
                    "children": []
                  },
                  {
                    "text": "OutputSpinners",
                    "link": "/packages/console-output/api/interfaces/OutputSpinners/",
                    "children": []
                  },
                  {
                    "text": "OutputStylesConfig",
                    "link": "/packages/console-output/api/interfaces/OutputStylesConfig/",
                    "children": []
                  },
                  {
                    "text": "Palette",
                    "link": "/packages/console-output/api/interfaces/Palette/",
                    "children": []
                  },
                  {
                    "text": "ProgressBarOptions",
                    "link": "/packages/console-output/api/interfaces/ProgressBarOptions/",
                    "children": []
                  },
                  {
                    "text": "Styles",
                    "link": "/packages/console-output/api/interfaces/Styles/",
                    "children": []
                  },
                  {
                    "text": "TreeData",
                    "link": "/packages/console-output/api/interfaces/TreeData/",
                    "children": []
                  },
                  {
                    "text": "TreeOptions",
                    "link": "/packages/console-output/api/interfaces/TreeOptions/",
                    "children": []
                  },
                  {
                    "text": "Trucolor",
                    "link": "/packages/console-output/api/interfaces/Trucolor/",
                    "children": []
                  },
                  {
                    "text": "TruncateOptions",
                    "link": "/packages/console-output/api/interfaces/TruncateOptions/",
                    "children": []
                  },
                  {
                    "text": "WrapOptions",
                    "link": "/packages/console-output/api/interfaces/WrapOptions/",
                    "children": []
                  }
                ]
              },
              {
                "text": "modules",
                "link": "/packages/console-output/api/modules/",
                "children": [
                  {
                    "text": "macros",
                    "link": "/packages/console-output/api/modules/macros/",
                    "children": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "/packages/core/": [
      {
        "text": "Core",
        "link": "/packages/core/",
        "children": [
          {
            "text": "api",
            "link": "/packages/core/api/",
            "children": [
              {
                "text": "classes",
                "link": "/packages/core/api/classes/",
                "children": [
                  {
                    "text": "Application",
                    "link": "/packages/core/api/classes/Application/",
                    "children": []
                  },
                  {
                    "text": "ArrayCollection",
                    "link": "/packages/core/api/classes/ArrayCollection/",
                    "children": []
                  },
                  {
                    "text": "CacheManager",
                    "link": "/packages/core/api/classes/CacheManager/",
                    "children": []
                  },
                  {
                    "text": "CacheServiceProvider",
                    "link": "/packages/core/api/classes/CacheServiceProvider/",
                    "children": []
                  },
                  {
                    "text": "Collection",
                    "link": "/packages/core/api/classes/Collection/",
                    "children": []
                  },
                  {
                    "text": "ConfigRepository",
                    "link": "/packages/core/api/classes/ConfigRepository/",
                    "children": []
                  },
                  {
                    "text": "CoreServiceProvider",
                    "link": "/packages/core/api/classes/CoreServiceProvider/",
                    "children": []
                  },
                  {
                    "text": "DirectoryStorage",
                    "link": "/packages/core/api/classes/DirectoryStorage/",
                    "children": []
                  },
                  {
                    "text": "Dispatcher",
                    "link": "/packages/core/api/classes/Dispatcher/",
                    "children": []
                  },
                  {
                    "text": "DispatcherMixin",
                    "link": "/packages/core/api/classes/DispatcherMixin/",
                    "children": []
                  },
                  {
                    "text": "FileCacheAdapter",
                    "link": "/packages/core/api/classes/FileCacheAdapter/",
                    "children": []
                  },
                  {
                    "text": "Manager",
                    "link": "/packages/core/api/classes/Manager/",
                    "children": []
                  },
                  {
                    "text": "PATH",
                    "link": "/packages/core/api/classes/PATH/",
                    "children": []
                  },
                  {
                    "text": "Process",
                    "link": "/packages/core/api/classes/Process/",
                    "children": []
                  },
                  {
                    "text": "ProcessManager",
                    "link": "/packages/core/api/classes/ProcessManager/",
                    "children": []
                  },
                  {
                    "text": "Repository",
                    "link": "/packages/core/api/classes/Repository/",
                    "children": []
                  },
                  {
                    "text": "Service",
                    "link": "/packages/core/api/classes/Service/",
                    "children": []
                  },
                  {
                    "text": "ServiceManager",
                    "link": "/packages/core/api/classes/ServiceManager/",
                    "children": []
                  },
                  {
                    "text": "SystemServiceProvider",
                    "link": "/packages/core/api/classes/SystemServiceProvider/",
                    "children": []
                  },
                  {
                    "text": "TypeDefinitionBuilder",
                    "link": "/packages/core/api/classes/TypeDefinitionBuilder/",
                    "children": []
                  }
                ]
              },
              {
                "text": "enums",
                "link": "/packages/core/api/enums/",
                "children": [
                  {
                    "text": "ExitCode",
                    "link": "/packages/core/api/enums/ExitCode/",
                    "children": []
                  },
                  {
                    "text": "ProxyFlags",
                    "link": "/packages/core/api/enums/ProxyFlags/",
                    "children": []
                  },
                  {
                    "text": "ServiceStatus",
                    "link": "/packages/core/api/enums/ServiceStatus/",
                    "children": []
                  }
                ]
              },
              {
                "text": "interfaces",
                "link": "/packages/core/api/interfaces/",
                "children": [
                  {
                    "text": "Bindings",
                    "link": "/packages/core/api/interfaces/Bindings/",
                    "children": []
                  },
                  {
                    "text": "CacheAdapter",
                    "link": "/packages/core/api/interfaces/CacheAdapter/",
                    "children": []
                  },
                  {
                    "text": "CacheConfiguration",
                    "link": "/packages/core/api/interfaces/CacheConfiguration/",
                    "children": []
                  },
                  {
                    "text": "ConfigPart",
                    "link": "/packages/core/api/interfaces/ConfigPart/",
                    "children": []
                  },
                  {
                    "text": "DirectoryStorage.JsonOptions",
                    "link": "/packages/core/api/interfaces/DirectoryStorage.JsonOptions/",
                    "children": []
                  },
                  {
                    "text": "DirectoryStorageOptions",
                    "link": "/packages/core/api/interfaces/DirectoryStorageOptions/",
                    "children": []
                  },
                  {
                    "text": "DispatcherEvents",
                    "link": "/packages/core/api/interfaces/DispatcherEvents/",
                    "children": []
                  },
                  {
                    "text": "EnvPaths",
                    "link": "/packages/core/api/interfaces/EnvPaths/",
                    "children": []
                  },
                  {
                    "text": "EnvPathsOptions",
                    "link": "/packages/core/api/interfaces/EnvPathsOptions/",
                    "children": []
                  },
                  {
                    "text": "FileCacheAdapterOptions",
                    "link": "/packages/core/api/interfaces/FileCacheAdapterOptions/",
                    "children": []
                  },
                  {
                    "text": "Hooks",
                    "link": "/packages/core/api/interfaces/Hooks/",
                    "children": []
                  },
                  {
                    "text": "ListenerFn",
                    "link": "/packages/core/api/interfaces/ListenerFn/",
                    "children": []
                  },
                  {
                    "text": "Paths",
                    "link": "/packages/core/api/interfaces/Paths/",
                    "children": []
                  },
                  {
                    "text": "PathSearchOptions",
                    "link": "/packages/core/api/interfaces/PathSearchOptions/",
                    "children": []
                  },
                  {
                    "text": "ProcessManagerData",
                    "link": "/packages/core/api/interfaces/ProcessManagerData/",
                    "children": []
                  },
                  {
                    "text": "SystemConfiguration",
                    "link": "/packages/core/api/interfaces/SystemConfiguration/",
                    "children": []
                  }
                ]
              },
              {
                "text": "modules",
                "link": "/packages/core/api/modules/",
                "children": [
                  {
                    "text": "DirectoryStorage",
                    "link": "/packages/core/api/modules/DirectoryStorage/",
                    "children": []
                  },
                  {
                    "text": "ServiceStatus",
                    "link": "/packages/core/api/modules/ServiceStatus/",
                    "children": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "/packages/shared/": [
      {
        "text": "Shared",
        "link": "/packages/shared/",
        "children": []
      }
    ],
    "/packages/multi-package-json-manager/": [
      {
        "text": "Multi Package Json Manager",
        "link": "/packages/multi-package-json-manager/",
        "children": [
          {
            "text": "api",
            "link": "/packages/multi-package-json-manager/api/",
            "children": [
              {
                "text": "classes",
                "link": "/packages/multi-package-json-manager/api/classes/",
                "children": [
                  {
                    "text": "JsonFileHandler",
                    "link": "/packages/multi-package-json-manager/api/classes/JsonFileHandler/",
                    "children": []
                  },
                  {
                    "text": "Manager",
                    "link": "/packages/multi-package-json-manager/api/classes/Manager/",
                    "children": []
                  }
                ]
              },
              {
                "text": "interfaces",
                "link": "/packages/multi-package-json-manager/api/interfaces/",
                "children": [
                  {
                    "text": "Change",
                    "link": "/packages/multi-package-json-manager/api/interfaces/Change/",
                    "children": []
                  },
                  {
                    "text": "FilePackageDetails",
                    "link": "/packages/multi-package-json-manager/api/interfaces/FilePackageDetails/",
                    "children": []
                  },
                  {
                    "text": "PackageJson",
                    "link": "/packages/multi-package-json-manager/api/interfaces/PackageJson/",
                    "children": []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "locales": {
    "/": {
      "selectLanguageName": "English"
    }
  },
  "logo": null,
  "darkMode": true,
  "repo": null,
  "selectLanguageText": "Languages",
  "selectLanguageAriaLabel": "Select language",
  "editLink": true,
  "lastUpdatedText": "Last Updated",
  "contributors": true,
  "contributorsText": "Contributors",
  "notFound": [
    "There's nothing here.",
    "How did we get here?",
    "That's a Four-Oh-Four.",
    "Looks like we've got some broken links."
  ],
  "backToHome": "Take me home",
  "openInNewWindow": "open in new window",
  "toggleDarkMode": "toggle dark mode",
  "toggleSidebar": "toggle sidebar"
}
